/**
 * Created by Ko-Hsin on 16/05/2018.
 */

import {Component, Input, Output,EventEmitter,ViewEncapsulation} from '@angular/core';
import {AuthService} from "../../../core/auth.service";
import {Source, Customer} from "../../../payment/models";
import {PaymentService} from "../../../payment/payment.service";
import {Observable} from "rxjs/Rx";
import {MatDialog} from "@angular/material/dialog";
import { PaymentSourceDeleteDialog, PaymentDialog} from "./dialogs";

@Component({
    selector: 'billing',
    template: `
<div>
    <div *ngIf="overview">
        <div class="standalone_title">Billing</div>
        <div *ngIf="pmt.customer" class="flex justify-between items-center flex-wrap">
            <div class="smaller_text">
                <div *ngIf="pmt.customer && pmt.customer.sources.data as sources; ">     
                    <div *ngIf="sources.length" >
                      <div *ngFor="let source of sources">
                        <div *ngIf="pmt.customer.default_source == source.id">
                            <span *ngIf="(auth.user | async) as user">{{user.displayName}}</span>
                            &nbsp; &nbsp; &nbsp;
                            {{ source.card.brand }} 
                            &bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;{{ source.card.last4 }} 
                        </div>
                
                      </div>
                    </div>
                </div>
            </div>
            <div>
                <button (click)="manage()">Update payment method</button>
            </div>
        </div>
    </div>
    <div *ngIf="!overview" class="panel">
        <alert-panel [(message)]="alert_message" ></alert-panel>
        <div class="standalone_title">Default Payment Method</div>
        <div *ngIf="pmt.customer && pmt.customer.sources.data as sources; " class="source_padding">     
            <div *ngIf="sources.length" >
              <div *ngFor="let source of sources">
                <div *ngIf="pmt.customer.default_source == source.id" class="flex items-center">
                    <div class="pill">
                        {{source.owner.name}}
                        &nbsp; &nbsp; &nbsp;
                        {{ source.card.brand }} 
                        &bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;{{ source.card.last4 }} 
                    </div><!--
                    <div class="action_btn" (click)="actions('edit',source)">Edit</div>-->
                </div>
        
              </div>
            </div>
        </div>
        <div *ngIf="pmt.customer && pmt.customer.sources.data.length > 1" class="standalone_title">Saved Payment Method<span *ngIf="pmt.customer && pmt.customer.sources.data.length > 2">s</span></div>
        <div *ngIf="pmt.customer && pmt.customer.sources.data as sources; " class="source_padding">     
            <div *ngIf="sources.length" >
              <div *ngFor="let source of sources">
                <div *ngIf="pmt.customer.default_source != source.id" class="flex items-center" [ngClass]="{loading:source._is_loading}">
                    <div class="pill loading" >
                        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                    </div>
                    <div *ngIf="source.owner && source.card" class="pill">
                        {{source.owner.name}}
                        &nbsp; &nbsp; &nbsp;
                        {{ source.card.brand }} 
                        &bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;{{ source.card.last4 }} 
                    </div>
                    <div class="action_btn" (click)="actions('make default',source)">Make Default </div><!--
                    <div class="action_btn" (click)="actions('edit',source)">Edit</div>-->
                    <div class="action_btn warning" (click)="actions('remove',source)">Remove</div>
                </div>
              </div>
            </div>
        </div>
        <button (click)="actions('add')">New Payment Method</button>
    </div>
</div>

    `,
    styles: [`
        
        .smaller_text { font-size: 14px; line-height: 24px; }
        .action_btn { cursor:pointer; margin-right: 10px; font-size: 12px; color: #999; }
        .action_btn:hover { color: #25f; }
        .action_btn.warning:hover { color:#fa0000; }
        .pill { border-radius: 100em; background-color: #eee; padding: 8px 16px; margin: 10px 20px 10px 0; font-size: 14px; }
        .loading .pill,
        .pill.loading  { display: none; }
        .loading .pill.loading { display: block; }
        .panel { background-color: #fff; padding: 25px; max-width: 1240px; margin:auto; }
        .source_padding { padding: 10px 0 30px; }
    .account_panel button { height: 30px;  font-family: "ff-netto-web",sans-serif; font-size: 14px; text-transform: uppercase; 
            letter-spacing: 1px; border:1px solid #ddd; border-radius:25px; color:#25f; margin:0 10px; cursor: pointer; padding:0 12px; 
            background: #FFF;}
    .account_panel button:hover { background: #EEF2F5; }

    `],
    encapsulation: ViewEncapsulation.None
})
export class BillingComponent {

    @Input()  overview: boolean;
    @Output() onManage = new EventEmitter<String>();
    alert_message;

    constructor(private pmt: PaymentService, private auth: AuthService, private dialog: MatDialog) { }

    ngOnInit() {
    }

    actions(action, src?){
        if(action == 'make default'){
        }
        //PaymentSourceDeleteDialog
        switch(action){
            case 'make default':
                src._is_loading = true;
                this.pmt.makeSourceDefault(src.id).subscribe(default_src=>{
                    console.log('default_src ',default_src);
                    src._is_loading = false;
                    this.pmt.customer.default_source = src.id;
                    this.alert_message = 'Updated method default successfully';
                })
                break;
            case 'edit':
            case 'add':
                const peDialog = this.dialog['open'](PaymentDialog,{
                    width: '480px',
                    data: { src:src }
                });

                peDialog.afterClosed().subscribe(data => {
                    if(data){
                        console.log('data ',data)
                        if(!data.amount){
                            this.pmt.customer.sources.data.push(data)
                            this.alert_message = 'Payment method added successfully';
                        }else{

                            this.alert_message = 'Updated method successfully';
                        }
                    }
                });
                break;
            case 'remove':
                const prDialog = this.dialog['open'](PaymentSourceDeleteDialog,{
                    width: '480px',
                    data: { src:src }
                });

                prDialog.afterClosed().subscribe(data => {
                    if(data){
                        src._is_loading = true;
                        this.pmt.removeSource(src.id).subscribe(deleted_src=>{
                            let delete_idx = -1;
                            this.pmt.customer.sources.data.forEach((src,idx)=>{
                                if(src.id == deleted_src.id) delete_idx = idx;
                            });
                            if(delete_idx > -1) this.pmt.customer.sources.data.splice(delete_idx,1);
                            this.alert_message = 'Method Successfully Removed';
                        });
                    }
                });
                break;
        }
    }

    manage(){
        this.onManage.emit('manage_payment_method');
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/account/components/billing.ts